import { tmrChecklistOperationController } from 'tmr/controllers/operation/checklistOperation'
import templateUrl from './outbound.html'
import icon from './outbound.svg'

/**
 * Outbound (Transfer to Place) Operation route.
 *
 * @namespace routes.OperationOutbound
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.outbound',
  label: 'OPERATIONS.OUTBOUND.TITLE',
  url: '/outbound',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
    placesCount: /*@ngInject*/ Place => Place.count(),
  },
  component: 'tmrOperationOutbound',
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Operation.perform', 'Operation.Outbound.perform'],
  },
  weight: 2,
  icon,
}

/**
 * Outbound Operation component
 *
 * @type {ngComponent}
 * @todo document
 */
export const tmrOperationOutbound = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationOutboundController',
  bindings: {
    antenna: '<',
    placesCount: '<',
    loggedUser: '<',
    productImageEnabled: '<',
  },
}

/**
 * Controller of component {@link tmrOperationOutbound}.
 *
 * @type {ngController}
 */
export class tmrOperationOutboundController extends tmrChecklistOperationController {
  constructor(
    debounce,
    $mdDialog,
    TmrToast,
    TmrMovementHelper,
    TmrMovementByUpcHelper,
    TmrOperationHelper,
    MovementOutbound,
    Place,
    Checklist,
    TmrChecklistNotFoundError
  ) {
    'ngInject'
    super(
      debounce,
      $mdDialog,
      TmrToast,
      TmrMovementHelper,
      TmrMovementByUpcHelper,
      TmrOperationHelper,
      Checklist,
      TmrChecklistNotFoundError
    )
    Object.assign(this, { MovementOutbound, Place, Checklist })
  }

  $onInit() {
    super.$onInit()
    this.customParcelCode = this.getConfig('outboundCustomParcelCode')
    this.customAsnCode = this.getConfig('outboundCustomAsnCode')
  }

  initVars() {
    super.initVars()
    this.checklistEnable = this.getConfig('outboundChecklistEnable')
  }

  /**
   * Load all places, then remove logged user's place
   */
  getPlaces(value) {
    return this.Place.search({ value }).$promise.then(places =>
      places.filter(place => place.id != this.loggedUser.place.id)
    )
  }

  onChangePlace() {
    this.onClear()
  }

  /**
   * Item read event, fired by {@link tmrAntennaControls}
   * Performs MovementOutbound.status requests in sequence.
   */
  onItemRead() {
    return this.detailsPromise
      .then(() => {
        this.loadingStatus = true
        return this.MovementOutbound.status(
          this.place,
          this.antenna.$items,
          this.description,
          this.asnCode,
          this.parcelCode,
          this.checklist
        ).$promise.then(
          details => this.buildGroupsDebounce(details),
          err =>
            this.TmrMovementHelper.statusError(err, this.antenna, this.onClear)
        )
      })
      .finally(() => (this.loadingStatus = false))
  }

  onConfirm() {
    super.onConfirm()
    return this.MovementOutbound.outbound(
      this.place,
      this.antenna.$items,
      this.description,
      this.asnCode,
      this.parcelCode,
      this.checklist
    )
      .$promise.then(
        movement => this.outboundSuccess(movement),
        err => this.TmrToast.exception(err)
      )
      .finally(() => this.onConfirmed())
  }

  outboundSuccess(movement) {
    this.movementAsnCode = movement.outboundParcel.asn.code
    this.asnCode = movement.outboundParcel.asn.code
    this.parcelCode = ''
    this.checklist = null
    this.checklistCode = ''
    this.TmrToast.success(
      'OPERATIONS.OUTBOUND.SUCCESS',
      {
        COUNT: this.antenna.$items.length,
        PARCEL: movement.outboundParcel.code,
      },
      'messageformat'
    )
    this.onClear()
  }

  onChangeCustomAsnCode(isOn, onValue) {
    this.customAsnCode = isOn
    this.setConfig('outboundCustomAsnCode', isOn)

    // Non cancellare subito l'asn se attivo il custom dopo averlo ricevuto da
    // outboundSuccess la prima volta che si attiva il campo custom.
    if (isOn && this.movementAsnCode === this.asnCode)
      this.movementAsnCode = null
    else this.asnCode = onValue
  }

  onChangeCustomParcelCode(isOn, onValue) {
    this.customParcelCode = isOn
    this.parcelCode = onValue
    this.setConfig('outboundCustomParcelCode', isOn)
  }

  onChecklistChange(isOn, onValue) {
    this.checklistCode = onValue
    this.checklist = null
    this.setConfig('outboundChecklistEnable', isOn)
    super.onChecklistChange(isOn)
  }
}
